import Api from '@/services/api.js';

export default {
  addVehicle(details) {
    return Api.post('vehicles/', details);
  },
  getVehicles(id) {
    if (!!id) {
      return this.getVehicleByContractor(id)
    } else {
      return this.getAllVehicles()
    }
  },
  getAllVehicles() {
    return Api.get('vehicles/');
  },


  deleteVehicle(vehicle) {
    return Api.delete(`vehicles/${vehicle}`);
  },

  updateVehicle(vehicle, id) {
    return Api.put(`vehicles/${id}`, vehicle);
  },

  // updateVehicle(vehicle) {
  //     var vehicleId = vehicle.id;
  //     return Api.put(`vehicles/${vehicleId}`, vehicle);
  // },
  getVehiclesByContractor(contractor) {
    return Api.get('vehicles/byContractor/' + contractor);
  },

  addVehicleType(details) {
    return Api.post('vehicles/types/', details);
  },
  updateVehicleType(vehicleType) {
    var vehicleTypeId = vehicleType.id;
    return Api.put(`vehicles/types/${vehicleTypeId}`, vehicleType);
  },
  getAllVehicleTypes() {
    return Api.get('vehicles/types/');
  },
  deleteVehicleType(id) {
    return Api.delete(`vehicles/types/${id}`);
  },

}